/* eslint-disable react/button-has-type */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../PaginatedFetchTable';
import Avatar from '../Avatar';
import Icon from '../Icon';
import Score from '../Score';
import StatusPill from '../StatusPill';
import LinkCopyButton from '../LinkCopyButton';


export default class StaffCompaniesList extends Component {
  static propTypes = {
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    batchActionsUrl: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    defaultSort: null,
    apiUrl: '',
  }

  constructor(props) {
    super(props);

    this.formRef = React.createRef();
    this.state = {
      hasApplication: this.props.columns.some((c) => c.title === 'Application'),
      batchActions: 0,
    };
  }

  renderRow = (item) => (
    <tr key={item.id}>
      <td>
        <a href={item.staff_url}>
          <div className="u-flex u-items-center">
            <Avatar
              className="StaffTable-avatar u-mr-2"
              src={item.avatar_url}
              type="company"
              showInitials
              name={item.name}
              />
            <div className="u-font-semibold u-truncate">
              {item.name}
            </div>
          </div>
        </a>
      </td>
      <td>
        <div className="u-truncate">
          {item.email
              && (
                <a href={`mailto:${item.email}`}>{item.email}</a>
              )}
        </div>
      </td>
      <td>
        <div className="u-truncate">
          {item.locations.join(', ')}
        </div>
      </td>
      <td>
        <div className="u-truncate">
          <Score rating={item.rating} />
        </div>
      </td>
      <td>
        <StatusPill status={item.state} />
      </td>
      {this.state.hasApplication
        && (
          <td>
            <select
              name={`batch_actions[${item.id}]`}
              className="u-m-0"
              style={{ maxHeight: '35px' }}
              onChange={this.handleBatchActionChange}
            >
              <option value="" selected>Select Action</option>
              {item.application_actions.map((o) => <option value={o.value}>{o.name}</option>)}
            </select>
          </td>
        )}
      <td className="actions">
        <a href={item.edit_staff_url} className="Button u-mr-2">
          <Icon name="edit" className="u-mr-0" />
        </a>
        <div className="u-inline-block">
          <LinkCopyButton url={item.public_url} name={item.name} />
        </div>
      </td>
    </tr>
  );

  handleBatchActionChange = (e) => {
    if (e.target.value !== 0) {
      this.setState(prevState => ({ batchActions: prevState.batchActions + 1 }));
    } else {
      this.setState(prevState => ({ batchActions: prevState.batchActions - 1 }));
    }
  };

  handleBatchActionReset = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.formRef.current.reset();
    this.setState({ batchActions: 0 });
  }

  renderBatchActions() {
    return (
      <>
        {(this.state.batchActions > 0)
          && (
            <div className="AlertBox AlertBox--fixedBottom u-bg-old-primary-color">
              <div className="u-flex u-items-center">
                <div className="u-text-left"> You have unsaved changes</div>
                <div className="u-text-right u-flex-grow">
                  <button
                    className="u-mb-0 u-mr-2 Button Button--primary Button--red"
                    onClick={this.handleBatchActionReset}
                    type="reset"
                    form="batch_actions">
                    <i className="Icon-close u-mr-2" />
                    <span>
                      {`Discard ${this.state.batchActions} ${this.state.batchActions > 1 ? 'updates' : 'update'}`}
                    </span>
                  </button>
                  <button className=" u-mb-0 u-mr-2 Button Button--primary" type="submit" form="batch_actions">
                    <i className="Icon-save u-mr-2" />
                    <span>
                      {`Save ${this.state.batchActions} ${this.state.batchActions > 1 ? 'updates' : 'update'}`}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}
      </>
    );
  }

  showBatchActions() {
    return this.state.batchActions > 0;
  }

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;

    return (
      <form id="batch_actions" ref={this.formRef} action={this.props.batchActionsUrl} method="post">
        <input
          type="hidden"
          name="authenticity_token"
          value={document.querySelector("meta[name='csrf-token']").getAttribute('content')}
        />
        <div className={this.showBatchActions() ? 'u-mb-12' : ''}>
          <PaginatedFetchTable
            apiUrl={apiUrl}
            perPage={perPage}
            emptyImg={emptyImg}
            columns={columns}
            defaultSort={defaultSort}
            renderRow={this.renderRow}
          />
        </div>
        {this.renderBatchActions()}
      </form>
    );
  }
}
